export default __webpack_public_path__ + "14.4ee83b.svg";